const financeOptions = [
  {
    title: 'Pay monthly',
    id: 'payMonthly',
    interestAPR: 4.9,
    monthsToPay: [
      { repaymentFactor: 0.042923, months: 24 },
      { repaymentFactor: 0.029023, months: 36 },
      { repaymentFactor: 0.022076, months: 48 },
      { repaymentFactor: 0.017910, months: 60 },
      { repaymentFactor: 0.015135, months: 72 },
    ],
    administrativeFee: 0
  },
  {
    title: 'Interest free credit',
    id: 'IFC',
    interestAPR: 0,
    monthsToPay: [
      { repaymentFactor: 0, months: 12 },
      { repaymentFactor: 0, months: 24 },
      { repaymentFactor: 0, months: 36 },
      { repaymentFactor: 0, months: 48 },
      { repaymentFactor: 0, months: 60 },
      { repaymentFactor: 0, months: 72 },
      { repaymentFactor: 0, months: 84 },
    ],
    administrativeFee: 0
  },
  {
    title: 'Buy now, pay later',
    id: 'BNPL',
    interestAPR: 11.9,
    monthsToPay: [{ repaymentFactor: 0.0229404538904431, months: 60 }],
    administrativeFee: 0
  },
]
const lowDeposit = 500
const highDeposit = 1000
const showFinance = false
const showBada = false
const hasMonthlyPayment = true
const hasFullVersion = true
const hasMagnetSimplifiedVersion = true
const ifcDepositFactors = {
  12: 0.1,
  24: 0.1,
  36: 0.1,
  48: 0.1,
  60: 0.1,
  72: 0.1,
  84: 0.1,
}
const ifcThreeYearMinSpend = 15000

export default {
  financeOptions,
  lowDeposit,
  highDeposit,
  showFinance,
  showBada,
  hasMonthlyPayment,
  hasFullVersion,
  hasMagnetSimplifiedVersion,
  ifcDepositFactors,
  ifcThreeYearMinSpend,
}
